import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";

export default function CompactInlineCountryCycler() {
  const countries = [
    "United States",
    "India",
    "Canada",
    "United Kingdom",
    "New Zealand",
    "Japan",
  ];
  const [currentCountry, setCurrentCountry] = useState(countries[0]);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentCountry((prevCountry) => {
          const currentIndex = countries.indexOf(prevCountry);
          const nextIndex = (currentIndex + 1) % countries.length;
          return countries[nextIndex];
        });
        setIsVisible(true);
      }, 500);
    }, 3000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        bgcolor: "transparent",
        textAlign: "center",
      }}
    >
      <Typography variant="body2" color="white">
        Made with <span style={{ color: "#f44336" }}>❤️</span> from
        <Box
          component="span"
          sx={{
            display: "inline-block",
            ml: 1,
            transition: "opacity 0.5s",
            opacity: isVisible ? 1 : 0,
          }}
        >
          <Typography
            component="span"
            variant="body2"
            sx={{ minWidth: "1ch", display: "inline-block", textAlign: "left" }}
          >
            {currentCountry}
          </Typography>
        </Box>
      </Typography>
    </Box>
  );
}
